/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var UiCursorAIcon16Regular = forwardRef('UiCursorAIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.005 3.324c.002-1.442 1.649-2.263 2.802-1.397l7.88 5.925c1.345 1.01.629 3.15-1.053 3.149l-3.93-.005a.25.25 0 0 0-.2.1l-2.361 3.141c-1.01 1.345-3.151.629-3.15-1.053l.012-9.86Zm1.9-.198a.25.25 0 0 0-.4.2l-.011 9.86c0 .24.305.342.45.15l2.361-3.141a1.75 1.75 0 0 1 1.401-.699l3.93.005a.25.25 0 0 0 .15-.45l-7.88-5.925Z" })));
});
